/** Truthy when user is currently interacting with an input or textarea element */
/** @deprecated - please use components in common/core/form */
export function deprecatedInteractingWithInput(): boolean {
  const activeElementTagName = window.document.activeElement?.tagName;
  return activeElementTagName === "INPUT" || activeElementTagName === "TEXTAREA";
}
